import React, {
  useState /*, useEffect*/,
  useContext,
} from "react";
import AuthContext from '../contexts/authContext';
import AuthHandler from "../services/api/authenticationHandler";

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(AuthContext);
};

function useProvideAuth() {
  const tokenValid = AuthHandler.isValidToken();
  const [isAuthenticated, setIsAuthenticated] = useState(tokenValid);

  const signin = async (username, password, cb) => {
    return AuthHandler.Authenticate({ username, password }).then((response) => {
      setIsAuthenticated(response.Success);

      if (cb) {
        cb(response);
      }
    });
  };

  const signout = () => {
    AuthHandler.SignOut();
    setIsAuthenticated(false);
  };

  const setReAuthCallback = (cb) => {
    AuthHandler.setReAuthCallback(cb);
  };

  const isValidToken = () => {
    return AuthHandler.isValidToken();
  }

  return {
    isAuthenticated,
    signin,
    signout,
    setReAuthCallback,
    isValidToken,
  };
}
